// AUDIO
export const GA_MET_PERCENTAGE_PROGRESS = 'percentage_progress';
export const GA_MET_TOTAL_LISTENING_TIME = 'total_listening_time';
export const GA_MET_SKIPPED_TIME = 'skipped_time';
export const GA_MET_START_POSITION = 'start_position';
export const GA_MET_END_POSITION = 'end_position';
export const GA_MET_SNAPPED_TO_POSITION = 'snapped_to_position';

// COMMON
export const GA_MET_RESULTS_COUNT = 'result_count';